// Virginia Tech's undergraduate majors (batch 2, #2652). Read on 2026-10-01
// from Virginia Tech's Undergraduate Majors page (vt.edu/academics/majors.html),
// its "Majors by College" tab, which lists the majors "available to incoming
// first-year applicants" under each college. That page gives no degree
// abbreviations, so degree is null. Left out: the undecided starting points
// (Business, Explore Science, Exploring Life Sciences and others, and
// University Studies), minors and transfer-only majors. Agricultural
// Technology is the one associate degree open to first-year applicants and
// keeps the page's own name. The KB's majors list was the starting point;
// the official page wins.
const majors = {
    "slug": "virginia-tech",
    "read": "2026-10-01",
    "intro": "Every major Virginia Tech lists as open to first-year applicants, grouped by the college that offers it. Undecided starting points, minors and transfer-only majors are left out.",
    "groups": [
        {
            "name": "College of Agriculture and Life Sciences",
            "source": {
                "label": "Virginia Tech, Undergraduate Majors, Majors by College",
                "url": "https://www.vt.edu/academics/majors.html"
            },
            "majors": [
                {
                    "name": "Agribusiness",
                    "degree": null
                },
                {
                    "name": "Agricultural Technology (Associate Degree)",
                    "degree": null
                },
                {
                    "name": "Agriculture and Extension Education",
                    "degree": null
                },
                {
                    "name": "Animal and Poultry Sciences",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Community Economic Development",
                    "degree": null
                },
                {
                    "name": "Community and Leadership Development",
                    "degree": null
                },
                {
                    "name": "Crop and Soil Sciences",
                    "degree": null
                },
                {
                    "name": "Dairy Science",
                    "degree": null
                },
                {
                    "name": "Ecological Restoration",
                    "degree": null
                },
                {
                    "name": "Environmental Economics: Management and Policy",
                    "degree": null
                },
                {
                    "name": "Environmental Horticulture",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": null
                },
                {
                    "name": "Exercise & Health Sciences",
                    "degree": null
                },
                {
                    "name": "Food and Health Systems Economics",
                    "degree": null
                },
                {
                    "name": "Food Science and Technology",
                    "degree": null
                },
                {
                    "name": "Integrated Agriculture Technologies",
                    "degree": null
                },
                {
                    "name": "International Trade and Development",
                    "degree": null
                },
                {
                    "name": "Landscape Design and Turfgrass Science",
                    "degree": null
                },
                {
                    "name": "Nutrition and Dietetics",
                    "degree": null
                },
                {
                    "name": "Plant Science",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Architecture, Arts, and Design",
            "source": {
                "label": "Virginia Tech, Undergraduate Majors, Majors by College",
                "url": "https://www.vt.edu/academics/majors.html"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Cinema",
                    "degree": null
                },
                {
                    "name": "Consumer Studies",
                    "degree": null
                },
                {
                    "name": "Creative Technologies",
                    "degree": null
                },
                {
                    "name": "Fashion Merchandising and Design",
                    "degree": null
                },
                {
                    "name": "Graphic Design",
                    "degree": null
                },
                {
                    "name": "Industrial Design",
                    "degree": null
                },
                {
                    "name": "Interior Design",
                    "degree": null
                },
                {
                    "name": "Landscape Architecture",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Property Management",
                    "degree": null
                },
                {
                    "name": "Residential Environments and Design",
                    "degree": null
                },
                {
                    "name": "Studio Art",
                    "degree": null
                },
                {
                    "name": "Theatre Arts",
                    "degree": null
                }
            ]
        },
        {
            "name": "Pamplin College of Business",
            "source": {
                "label": "Virginia Tech, Undergraduate Majors, Majors by College",
                "url": "https://www.vt.edu/academics/majors.html"
            },
            "majors": [
                {
                    "name": "Accounting and Business Analysis",
                    "degree": null
                },
                {
                    "name": "Accounting and Information Systems",
                    "degree": null
                },
                {
                    "name": "Business Information Technology",
                    "degree": null
                },
                {
                    "name": "Cybersecurity Management and Analytics",
                    "degree": null
                },
                {
                    "name": "Entrepreneurship, Innovation and Technology Management",
                    "degree": null
                },
                {
                    "name": "Event and Experience Management",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Financial Planning and Wealth Management",
                    "degree": null
                },
                {
                    "name": "FinTech and Big Data Analytics",
                    "degree": null
                },
                {
                    "name": "Hospitality and Tourism Management",
                    "degree": null
                },
                {
                    "name": "Human Resource Management",
                    "degree": null
                },
                {
                    "name": "Management",
                    "degree": null
                },
                {
                    "name": "Management Consulting and Analytics",
                    "degree": null
                },
                {
                    "name": "Marketing Management",
                    "degree": null
                },
                {
                    "name": "Professional Sales in Marketing",
                    "degree": null
                },
                {
                    "name": "Real Estate",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Virginia Tech, Undergraduate Majors, Majors by College",
                "url": "https://www.vt.edu/academics/majors.html"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": null
                },
                {
                    "name": "Biological Systems Engineering",
                    "degree": null
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": null
                },
                {
                    "name": "Building Construction",
                    "degree": null
                },
                {
                    "name": "Chemical Engineering",
                    "degree": null
                },
                {
                    "name": "Civil Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Engineering",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Construction Engineering and Management",
                    "degree": null
                },
                {
                    "name": "Electrical Engineering",
                    "degree": null
                },
                {
                    "name": "Engineering Science and Mechanics",
                    "degree": null
                },
                {
                    "name": "General Engineering",
                    "degree": null
                },
                {
                    "name": "Industrial and Systems Engineering",
                    "degree": null
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": null
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": null
                },
                {
                    "name": "Mining Engineering",
                    "degree": null
                },
                {
                    "name": "Ocean Engineering",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Liberal Arts and Human Sciences",
            "source": {
                "label": "Virginia Tech, Undergraduate Majors, Majors by College",
                "url": "https://www.vt.edu/academics/majors.html"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": null
                },
                {
                    "name": "Arabic",
                    "degree": null
                },
                {
                    "name": "Career and Technical Education",
                    "degree": null
                },
                {
                    "name": "Career and Technical Education - Agriculture Education",
                    "degree": null
                },
                {
                    "name": "Classical Studies",
                    "degree": null
                },
                {
                    "name": "Communication",
                    "degree": null
                },
                {
                    "name": "Creative Writing",
                    "degree": null
                },
                {
                    "name": "Criminology",
                    "degree": null
                },
                {
                    "name": "Early Childhood Development and Education",
                    "degree": null
                },
                {
                    "name": "Elementary Education (PK-6)",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "English Language Arts Education",
                    "degree": null
                },
                {
                    "name": "Environment, Development, and Global Economy",
                    "degree": null
                },
                {
                    "name": "Environmental Policy and Planning",
                    "degree": null
                },
                {
                    "name": "French",
                    "degree": null
                },
                {
                    "name": "German",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "History and Social Sciences Education",
                    "degree": null
                },
                {
                    "name": "Human Development",
                    "degree": null
                },
                {
                    "name": "International Relations",
                    "degree": null
                },
                {
                    "name": "International Studies",
                    "degree": null
                },
                {
                    "name": "Mathematics Education",
                    "degree": null
                },
                {
                    "name": "Multimedia Journalism",
                    "degree": null
                },
                {
                    "name": "National Security and Foreign Affairs",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Philosophy, Politics, and Economics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Public Relations",
                    "degree": null
                },
                {
                    "name": "Russian",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish",
                    "degree": null
                },
                {
                    "name": "Sports Media and Analytics",
                    "degree": null
                },
                {
                    "name": "Technical and Scientific Communication",
                    "degree": null
                },
                {
                    "name": "Technology Education",
                    "degree": null
                },
                {
                    "name": "Urban Planning",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Natural Resources and Environment",
            "source": {
                "label": "Virginia Tech, Undergraduate Majors, Majors by College",
                "url": "https://www.vt.edu/academics/majors.html"
            },
            "majors": [
                {
                    "name": "Environmental Conservation and Society",
                    "degree": null
                },
                {
                    "name": "Environmental Data Science",
                    "degree": null
                },
                {
                    "name": "Environmental Resources Management",
                    "degree": null
                },
                {
                    "name": "Fish Conservation",
                    "degree": null
                },
                {
                    "name": "Forestry",
                    "degree": null
                },
                {
                    "name": "Geography",
                    "degree": null
                },
                {
                    "name": "Meteorology",
                    "degree": null
                },
                {
                    "name": "Packaging Systems and Design",
                    "degree": null
                },
                {
                    "name": "Sustainable Systems Science (S3)",
                    "degree": null
                },
                {
                    "name": "Water: Resources, Policy, and Management",
                    "degree": null
                },
                {
                    "name": "Wildlife Conservation",
                    "degree": null
                }
            ]
        },
        {
            "name": "College of Science",
            "source": {
                "label": "Virginia Tech, Undergraduate Majors, Majors by College",
                "url": "https://www.vt.edu/academics/majors.html"
            },
            "majors": [
                {
                    "name": "Biological Sciences (Biology)",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Clinical Neuroscience",
                    "degree": null
                },
                {
                    "name": "Cognitive and Behavioral Neuroscience",
                    "degree": null
                },
                {
                    "name": "Computational and Systems Neuroscience",
                    "degree": null
                },
                {
                    "name": "Computational Modeling and Data Analytics",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Geosciences",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Medicinal Chemistry",
                    "degree": null
                },
                {
                    "name": "Microbiology",
                    "degree": null
                },
                {
                    "name": "Nanomedicine",
                    "degree": null
                },
                {
                    "name": "Nanoscience",
                    "degree": null
                },
                {
                    "name": "Neuroscience",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Polymer Chemistry",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Statistics",
                    "degree": null
                }
            ]
        },
        {
            "name": "Virginia-Maryland College of Veterinary Medicine",
            "source": {
                "label": "Virginia Tech, Undergraduate Majors, Majors by College",
                "url": "https://www.vt.edu/academics/majors.html"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
